import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "orderlineitem",
  listKey: "items",
  itemKey: "item",
  getAll: types.GET_ALL_ORDER_LINE_ITEMS,
  getAllResponse: types.GET_ALL_ORDER_LINE_ITEMS_RESPONSE,
  getByIdResponse: types.GET_ORDER_LINE_ITEM_BY_ID_RESPONSE,
});
